import type { Router } from '@angular/router';

import type { ItemInfo } from '@core/models/navigation-item.model';
import { MY_PROFILE_URL } from '@shared/constants/ume-constants';

import { MY_PROFILE_ROUTES_LIST } from '../../routes/my-profile/constants/my-profile.constants';
import { setRestrictedAccessRoute } from '../guards/navigationLink.guard';
import type { CustomEventService } from '../repository/customEvent.service';

export function handleNavigationClick(
  item: ItemInfo,
  event: MouseEvent,
  router: Router,
  customEventService: CustomEventService
): void {
  if (item.payment) {
    event.preventDefault();
    router.navigate(['/', 'plans', 'comparison']);
    return;
  }

  if (item.noProfile) {
    event.preventDefault();
    router.navigate(['/', MY_PROFILE_URL, MY_PROFILE_ROUTES_LIST.COMPANY_DETAILS]);
    return;
  }

  if (item.disabled) {
    event.preventDefault();
    redirectToRestrictedUserRights(item, router);
    return;
  }

  if (item.requestUrl) {
    if (item.disabled || item.disabledReason) {
      redirectToRestrictedUserRights(item, router);
      return;
    }

    customEventService.handleCustomEvent(item.requestUrl);
  }
}

export function redirectToRestrictedUserRights(item: ItemInfo, router: Router): void {
  const label: string | string[] = setRestrictedAccessRoute(item.menuLabel);
  if (!label || label === '') {
    router.navigate(['/', 'restricted-user-rights']);
    return;
  }

  router.navigate(['/', ...(Array.isArray(label) ? label : [label]), 'restricted-user-rights'], {
    queryParams: { disabledReason: item.disabledReason || null },
  });
}
